import * as React from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { getTheme } from './get-theme';
export const ThemeProviderContext = React.createContext({});
const InnerThemeProvider = ({ children, context, themeContextOptions, language, direction, theme }) => {
    const memoizedValue = React.useMemo(() => (Object.assign(Object.assign({}, context), themeContextOptions)), [context, themeContextOptions]);
    // Hint: Do not remove the fragment (<>...</>) below. It is absolutely
    // necessary to ensure the theme provider's children have the correct type.
    return (React.createElement(ThemeProviderContext.Provider, { value: memoizedValue },
        React.createElement(StyledComponentsThemeProvider, { theme: (currentTheme) => getTheme(currentTheme, theme, language, direction) },
            React.createElement(React.Fragment, null, children))));
};
/**
 * ThemeProvider component
 *
 * Provides a theme object to all it's child components via `styled-components`' ThemeProvider
 *
 * @param props Component properties
 */
export function ThemeProvider(props) {
    const { children, direction, language, theme, themeContextOptions } = props;
    const validChildren = React.Children.toArray(children).filter(React.isValidElement);
    if (validChildren.length === 0) {
        return null;
    }
    return (React.createElement(ThemeProviderContext.Consumer, null, (context) => (React.createElement(InnerThemeProvider, { context: context, themeContextOptions: themeContextOptions, direction: direction, language: language, theme: theme }, validChildren))));
}
